<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">名称</span>
        <el-input
          v-model="parameter.name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        @click="func"
      >创建</el-button>
      <el-button
        class="filter-item"
        type="warning"
        @click="syncAccount"
      >自动绑定</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
        />
        <el-table-column
          prop="name"
          label="小程序名称"
        />
        <el-table-column
          prop="account_total"
          label="绑定广告主"
        />
        <el-table-column
          prop="ad_remark"
          label="广告主标签"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          label="操作"
        >
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="modify(scope.row)"
            >修改</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteMy(scope.row)"
            >删除</el-button>
            <el-button
              type="warning"
              size="mini"
              @click="miniProgramAccount(scope.row)"
            >广告主列表</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改小程序' : '创建小程序'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.name = null),(data.id = null), (data.leader_id = null),(app_id = null),(app_ids = null)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">小程序名称</span>
          <el-input
            v-model="data.name"
            class="item_input"
          />
          <div style="height: 20px;width: 10px"></div>
          <span class="item_title">广告主标签</span>
          <el-input
            v-model="data.ad_remark"
            class="item_input"
          />
        </div>
      </div>
      <div style="display: flex; margin-top: 30px; justify-content: end;">
        <el-button
          type="primary"
          @click="determine"
        >确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="确定提交小程序自动绑定吗?"
      :visible.sync="ed_peo_visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="margin-top: 10px">
        <el-button type="success" @click="updAdCustom">确定</el-button>
        <el-button type="info" @click="ed_peo_visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAPPList, updateAPP, addAPP, deleteApp, syncAccount
} from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        name: null
      },
      data: {
        name: null,
        ad_remark: null,
        id: null
      },
      dialogVisible: false,
      pageinfo: {
        page: 1,
        pageSize: 10
      },
      app_ids: null,
      ed_peo_visible: false,
      account_item: null
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getAPPList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    async modify(row) {
      this.dialogVisible = true
      this.data.name = row.name
      this.data.ad_remark = row.ad_remark
      this.data.id = row.id
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.name) {
        text = '请填写名称'
      }
      if (!text) {
        const data = {}
        this.data.id ? await updateAPP({ ...this.data, ...data }) : await addAPP({ ...this.data, ...data })
      }

      this.$message({
        message: text ? '请填写名称' : this.data.id ? '更新成功' : '创建成功',
        type: text ? 'warning' : 'success'
      })

      if (!text) {
        this.data.name = null
        this.data.leader_id = null
        this.data.id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    async func() {
      this.dialogVisible = true
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        name: null
      }
      this.getDataList()
    },

    // 删除
    deleteMy(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await deleteApp(row.id)
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    miniProgramAccount(val) {
      this.$router.push({
        path: '/TKreleaseGroup/sendcicle/index',
        query: { id: val.id }
      })
    },
    syncAccount() {
      this.ed_peo_visible = true
    },
    getRowKeys(row) {
      return row.id
    },
    updAdCustom() {
      syncAccount().then(res => {
        if (res.code === 0) {
          this.$message.success('绑定成功')
          this.ed_peo_visible = false
        }
      })
    },
    delAd(val) {
      this.account_item = this.account_item.filter(item => {
        return item.id !== val.id
      })
      this.account_ids = this.account_ids.filter(item => {
        return item !== val.id
      })
      if (this.account_ids.length === 0) {
        this.ed_peo_visible = false
      }
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.selectionArea {
  display: flex;
}

.content {
  .item {
    align-items: center;
    margin-bottom: 15px;

    .item_title {
      display: inline-block;
      width: 100px;
    }

    .item_input {
      width: 200px;
    }
  }
}

.item {
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
